import {
  ACCESSORIES_FETCHED_SUCCESS,
  ACCESSORIES_FETCHED_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const accessoriesFetchedAction = (status) => async (dispatch) => {
  try {
    dispatch({
      type: ACCESSORIES_FETCHED_SUCCESS,
      payload: status,
    });
  } catch (err) {
    log.error('Error dispatching accessories fetched action', err);
    dispatch({
      type: ACCESSORIES_FETCHED_FAILURE,
      payload: status,
    });
  }
};

export default accessoriesFetchedAction;
